export const awards = [
  { title: "Futury Build_Days AI Hackathon", placement: "1st Place", year: "2025", rank: "01" },
  { title: "Generative AI Competition", placement: "1st Place", year: "2024", rank: "01" },
  { title: "PwC Hackathon", placement: "1st Place", year: "2023", rank: "01" },
  { title: "Africa Fintech Hub Competition", placement: "First Runner-Up", year: "2023", rank: "02" },
] as const;
